import React, { useState } from 'react';
import Banner from './Components/banner';
import LooseBan from '../../Assets/images/education-web/loose-ban.png';
import { Col, Container, Row, Tab, Tabs } from 'react-bootstrap';

import Cut from '../../Assets/images/education-web/cut.png';
import Clarity from '../../Assets/images/education-web/clarityy.png';
import Color from '../../Assets/images/education-web/color.png';
import Carat from '../../Assets/images/education-web/carat.png';
import Diamond from '../../Assets/images/education-web/diamond.png';

import Asscher from '../../Assets/images/education-web/Asscher.png';
import Round from '../../Assets/images/education-web/Round.png';
import Princess from '../../Assets/images/education-web/Princess.png';
import Cushion from '../../Assets/images/education-web/Cushion.png';
import Emerald from '../../Assets/images/education-web/Emerald.png';
import Pear from '../../Assets/images/education-web/Pear.png';
import Radiant from '../../Assets/images/education-web/Radiant.png';
import Oval from '../../Assets/images/education-web/Oval.png';
import Heart from '../../Assets/images/education-web/Heart.png';
import Marquise from '../../Assets/images/education-web/Marquise.png';

import RealAsscher from '../../Assets/images/education-web/realD-1.png';
import RealRound from '../../Assets/images/education-web/realD-2.png';
import RealPrincess from '../../Assets/images/education-web/realD-3.png';
import RealCushion from '../../Assets/images/education-web/realD-4.png';
import RealEmerald from '../../Assets/images/education-web/realD-5.png';
import RealPear from '../../Assets/images/education-web/realD-6.png';
import RealRadiant from '../../Assets/images/education-web/realD-7.png';
import RealOval from '../../Assets/images/education-web/realD-8.png';
import RealHeart from '../../Assets/images/education-web/realD-9.png';
import RealMarquise from '../../Assets/images/education-web/realD-10.png';

import diamondImage from '../../Assets/images/education-web/diamond-yellow.png';
import Anatomy from '../../Assets/images/education-web/anatomy.png';

import Cut1 from '../../Assets/images/education-web/cut-1.png';
import Color1 from '../../Assets/images/education-web/color-1.png';
import Carat1 from '../../Assets/images/education-web/carat-1.png';
import Clarity1 from '../../Assets/images/education-web/clarity-1.png';

import Loose from '../../Assets/images/education-web/loose.svg';
import Ring from '../../Assets/images/education-web/ring.svg';
import Gem from '../../Assets/images/education-web/gems.svg';
import Fine from '../../Assets/images/education-web/fine.svg';

import Help from './Components/help';
import Scrollspy from 'react-scrollspy';
import { Link } from 'react-router-dom';



const LooseDiamondEducation = () => {
  return (
    <>
        <Banner title={'Loose Diamonds'} bannerImg={LooseBan} nestedBreadCrumb />

        <div className='content-wrapper loose-diamond-page'>
            <Container>
                <ul className='education-tabs'>
                    <li className='active'>
                        <Link to="/education/loose-diamonds-education">
                            <img src={Loose} alt='' />
                            <h3>Loose Diamonds</h3>
                        </Link>
                    </li>

                    <li>
                        <Link to="/education/engagement-ring-education">
                            <img src={Ring} alt='' />
                            <h3>Engagement Ring</h3>
                        </Link>
                    </li>

                    <li>
                        <Link to="/education/gemstone-education">
                            <img src={Gem} alt='' />
                            <h3>Gemstones</h3>
                        </Link>
                    </li>

                    <li>
                        <Link to="/education/wedding-ring-education">
                            <img src={Ring} alt='' />
                            <h3>Wedding Ring</h3>
                        </Link>
                    </li>

                    <li>
                        <Link to="/education/fine-jewelry-education">
                            <img src={Fine} alt='' />
                            <h3>Fine Jewelry</h3>
                        </Link>
                    </li>
                </ul>
            </Container>

            <Container>
                <h2 className='heading'>Table of Content</h2>
                <ul className='table-of-content mt-4'>
                    <li>
                        <a href="#section-1">
                            <h4>4C’s of Diamonds</h4>
                            <p>The cut of a diamond not only refers to the diamond’s shape.</p>
                            <img src={Diamond} alt="" />
                        </a>
                    </li>
                    <li>
                        <a href="#section-2">
                            <h4>Cut</h4>
                            <p>The cut of a diamond not only refers to the diamond’s shape.</p>
                            <img src={Diamond} alt="" />
                        </a>
                    </li>
                    <li>
                        <a href="#section-3">
                            <h4>Color</h4>
                            <p>The cut of a diamond not only refers to the diamond’s shape.</p>
                            <img src={Diamond} alt="" />
                        </a>
                    </li>
                    <li>
                        <a href="#section-4">
                            <h4>Carat</h4>
                            <p>The cut of a diamond not only refers to the diamond’s shape.</p>
                            <img src={Diamond} alt="" />
                        </a>
                    </li>
                    <li>
                        <a href="#section-5">
                            <h4>Clarity</h4>
                            <p>The cut of a diamond not only refers to the diamond’s shape.</p>
                            <img src={Diamond} alt="" />
                        </a>
                    </li>
                    <li>
                        <a href="#section-6">
                            <h4>Shapes</h4>
                            <p>The cut of a diamond not only refers to the diamond’s shape.</p>
                            <img src={Diamond} alt="" />
                        </a>
                    </li>
                    <li>
                        <a href="#section-7">
                            <h4>Anatomy</h4>
                            <p>The cut of a diamond not only refers to the diamond’s shape.</p>
                            <img src={Diamond} alt="" />
                        </a>
                    </li>
                    <li>
                        <a href="#section-8">
                            <h4>Diamond Care</h4>
                            <p>The cut of a diamond not only refers to the diamond’s shape.</p>
                            <img src={Diamond} alt="" />
                        </a>
                    </li>
                </ul>
            </Container>

            <Row className='m-0'>
                <Col xl={2} lg={1} className='p-0 d-xl-block d-none'>
                    <div className='sticky-breadcrumb px-5'>
                        <h4>Table of Content</h4>
                        <Scrollspy offset={200} items={ ['section-1', 'section-2', 'section-3', 'section-4', 'section-5', 'section-6', 'section-7', 'section-8'] } currentClassName="is-current">
                            <li><a href="#section-1">4C’s of Diamonds</a></li>
                            <li><a href="#section-2">Cut</a></li>
                            <li><a href="#section-3">Color</a></li>
                            <li><a href="#section-4">Carat</a></li>
                            <li><a href="#section-5">Clarity</a></li>
                            <li><a href="#section-6">Shapes</a></li>
                            <li><a href="#section-7">Anatomy</a></li>
                            <li><a href="#section-8">Diamond Care</a></li>
                        </Scrollspy>
                    </div>
                </Col>

                <Col xl={10} lg={12}>
                    <Container className='section-overlap loose-diamond-page ml-0'>
                        
                        <h2 className='heading mt-80' id="section-1">4C’s of Diamonds</h2>
                        <Row className='mt-80 position-relative diamond-tabs-wrapper align-items-center'>
                            <img src={diamondImage} alt='' />
                            <Tabs
                                defaultActiveKey="cut"
                                id="uncontrolled-tab-example"
                                className="diamond-tabs"
                                >
                                <Tab eventKey="cut" title="Cut">
                                    <h2 className='sub-heading'>Diamond Cut</h2>
                                    <p>The cut of a diamond not only refers to the diamond’s shape, it also refers to how effectively the diamond returns light back to the viewer’s eye. A well-cut diamond will appear very brilliant and fiery, while a poorly cut diamond can appear dark and lifeless, regardless of its color or clarity.</p>
                                    <p>Not only do well-cut diamonds appear more brilliant, they also tend to appear larger than other diamonds of the same carat weight. An "ideal" diamond has both increased brilliance and diameter relative to more deeply-cut diamonds.</p>
                                    <img src={Cut1} alt='' />
                                </Tab>
                                <Tab eventKey="color" title="Color">
                                    <h2 className='sub-heading'>Diamond Color</h2>
                                    <p>When shopping for a diamond, it is generally preferred to choose a stone with the least amount of color possible. Diamond color is graded on a scale from D-Z and is divided into five broad categories (colorless, near colorless, faint, very light and light). Diamonds come in all colors of the spectrum. The predominant color you see in a diamond is yellow, which is caused by the trace element nitrogen.</p>
                                    <img src={Color1} alt='' />
                                </Tab>
                                <Tab eventKey="carat" title="Carat">
                                    <h2 className='sub-heading'>Diamond Carat</h2>
                                    <p>Carat is a term that refers to the weight of a diamond. Prior to the twentieth century, diamonds were measured using carob seeds, which were small and uniform and served as a perfect counter weight to the diamond. The word "carob” is the origin of the word "carat" that we use today.</p>
                                    <img src={Carat1} alt='' />
                                </Tab>
                                <Tab eventKey="clarity" title="Clarity">
                                    <h2 className='sub-heading'>Diamond Clarity</h2>
                                    <p>It is important to select a diamond that does not have any inclusions that will affect the overall beauty and durability of the diamond. If you want to be 100% sure that your diamond will be completely clean of "eye-visible" inclusions, stick with diamonds graded "VS2" or higher. Shopping for SI quality diamonds can be very rewarding, but it's best to have those diamonds reviewed by James Allen’s expert staff before finalizing your order.</p>
                                    <img src={Clarity1} alt='' height={160} />
                                </Tab>
                            </Tabs>
                        </Row>

                        <Row className='mt-100' id='section-2'>
                            <Col lg={8} md={12}>
                                <h2 className='heading' id="section-1">Cut of Diamonds</h2>
                                <p>The cut of a diamond refers not to its shape, but to the balance of proportion, symmetry and polish achieved by the diamond cutter. The extent of how well the diamond is cut is directly related to the diamond’s overall beauty. When a diamond has been correctly cut, the diamond’s ability to reflect and refract light is greatly enhanced. By understanding the way that light moves through diamond crystals, modern diamond cutters have established a specific set of proportions and angles that are known to harness the diamond’s internal brilliance and to show it in its best light.</p>

                                <h2 className='sub-heading'>Ideal Cut</h2>
                                <p>An Ideal Cut Diamond is a round, brilliant, or princess cut diamond that is cut to ideal proportions and angles, and has excellent polish and symmetry ratings. An Ideal Cut Diamond is perfectly proportioned to refract light, producing that fire and brilliance up through to the table and crown. Belgium WebNet offers a nice selection of Ideal Cut Diamonds know at True HeartsTM</p>
                            </Col>

                            <Col lg={4} md={12} className='align-self-center text-center'>
                                <img className='text-center' src={Cut} alt='' />
                            </Col>
                        </Row>

                        <Row className='mt-80 mt-80 flex-row-reverse' id='section-3'>
                            <Col lg={8} md={12}>
                                <h2 className='heading' id="section-1">Color</h2>
                                <p>Color refers to the natural body color of a diamond and not to the reflection of spectral colors that flash when a diamond moves. Most diamonds naturally exhibit slight hints of yellow, brown, or gray. This color is caused by natural trace elements of nitrogen that were present when the diamond formed under the Earth’s crust. The less color a diamond exhibits, the higher the rarity, and therefore the higher the value.</p>

                                <h2 className='sub-heading'>Diamond Color</h2>
                                <p>Color of a diamond is a result of diamond’s composition and does not change with time. Colorless diamonds allow light to travel through them as compared to the colored diamonds. These diamonds also emit more fire and sparkle. The process, through which a diamond is formed, is the deciding factor for its color. The whiter the diamond is the higher value it will have. For grading the color of diamonds, jewelers refer to GIA’s color scale that starts the rating with D for the colorless diamonds and grows up to Z as the traces of light yellow or brown color are found in the diamond. Diamonds graded from D to F are amongst the most desirable and valuable stones. These diamonds are a delight for the diamond lovers. Nevertheless, if you have a low budget, you can also find good diamonds with lower grades. These diamonds are not exactly colorless but show no color to untrained eye</p>
                            </Col>

                            <Col lg={4} md={12} className='align-self-center text-center'>
                                <img className='text-center' src={Color} alt='' />
                            </Col>
                        </Row>

                        <Row className='mt-80' id='section-4'>
                            <Col lg={8} md={12}>
                                <h2 className='heading' id="section-1">Carat</h2>
                                <p>Carat (ct.) refers to the unique unit of weight measurement used exclusively to weigh gems and diamonds. Carat weight is often confused with visual size even though it is actually a measurement of weight. Depending on the shape and type of gemstone being weighed, the weight will visually show itself differently. For example, a 1.00 ct. round diamond will measure around 6.5mm, and a 1.00 ct. round sapphire will measure around 6.0mm. This is due to the varying density of different gemstones.</p>

                                <h2 className='sub-heading'>Carat Weight</h2>
                                <p>Diamond clarity means finding out characteristics of a diamond, including the blemishes and inclusions. If you consider the pressure that a diamond is created, and that they are not produced in sterile laboratory, you will be not be surprised to find that most of these diamonds are not free of flaws. Usually there are two kinds of flaws found in diamonds – blemishes and inclusions. Inclusions are naturally occurring internal flaws that are found in diamonds including cracks, air bubbles, and mineral. However, most blemishes occur at the time of cutting process.</p>
                            </Col>

                            <Col lg={4} md={12} className='align-self-center text-center'>
                                <img className='text-center' src={Carat} alt='' />
                            </Col>
                        </Row>

                        <Row className='mt-80 flex-row-reverse' id='section-5'>
                            <Col lg={8} md={12} className='align-self-center'>
                                <h2 className='heading' id="section-1">Clarity</h2>
                                <p>Clarity refers to how clean or clear the diamond is with respect to natural microscopic characteristics that were trapped within or on the diamond while it was forming. Internal characteristics are known as inclusions, and characteristics on the surface of the gem are known as blemishes. Inclusions may be crystals of a foreign material or structural imperfections such as tiny cracks, known as feathers, which can appear whitish or cloudy.</p>

                                <h2 className='sub-heading'>Diamond Clarity</h2>
                                <p>Diamond clarity means finding out characteristics of a diamond, including the blemishes and inclusions. If you consider the pressure that a diamond is created, and that they are not produced in sterile laboratory, you will be not be surprised to find that most of these diamonds are not free of flaws. Usually there are two kinds of flaws found in diamonds – blemishes and inclusions. Inclusions are naturally occurring internal flaws that are found in diamonds including cracks, air bubbles, and mineral. However, most blemishes occur at the time of cutting process.</p>
                            </Col>

                            <Col lg={4} md={12} className='align-self-center text-center'>
                                <img className='text-center' src={Clarity} alt='' />
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>

            <div className='bg-dull grid-section diamond-types mt-50 py-5' id="section-6">
                <Container>
                    <Row>
                        <Col xl={2}></Col>
                        
                        <Col xl={10}>
                            <h2 className='heading mt-5'>Shape of Diamonds</h2>
                            <Row className='mt-50'>
                                <Col lg={4} md={6} className='mb-5'>
                                    <img src={Asscher} onMouseOver={(e) => e.currentTarget.src = RealAsscher} onMouseOut={(e) => e.currentTarget.src = Asscher} className='mb-3' width={120} alt="" />
                                    <h2>Asscher Diamonds</h2>
                                    <p>The asscher cut features a square shape with cut corners. A high crown with large step cut facets bestows more brilliance than the other popular step cut shape, the emerald shape. Asscher shaped diamonds are sleek and modern in solitaire settings, and their unique shape perfectly complements vintage-inspired styles.</p>
                                </Col>

                                <Col lg={4} md={6} className='mb-5'>
                                    <img src={Round} className='mb-3' onMouseOver={(e) => e.currentTarget.src = RealRound} onMouseOut={(e) => e.currentTarget.src = Round} width={120} alt="" />
                                    <h2>Round Diamonds</h2>
                                    <p>Diamond shape refers to a diamond’s physical form, and is often one of the first attributes that couples consider when shopping for a diamond. While round diamonds are the most popular choice, many couples are also drawn to the distinctive look of non-round, or “fancy shaped” diamonds. </p>
                                </Col>

                                <Col lg={4} md={6} className='mb-5'>
                                    <img src={Princess} className='mb-3' onMouseOver={(e) => e.currentTarget.src = RealPrincess} onMouseOut={(e) => e.currentTarget.src = Princess} width={120} alt="" />
                                    <h2>Princess Diamonds</h2>
                                    <p>Princess cut diamonds are the second most popular diamond shape. Princess cut diamonds possess the gorgeous sparkle of round brilliant diamonds in a distinctive square shape. They offer a contemporary look and the flexibility to work in almost any style of ring.</p>
                                </Col>

                                <Col lg={4} md={6} className='mb-5'>
                                    <img src={Cushion} className='mb-3' onMouseOver={(e) => e.currentTarget.src = RealCushion} onMouseOut={(e) => e.currentTarget.src = Cushion} width={120} alt="" />
                                    <h2>Cushion Diamonds</h2>
                                    <p>Cushion cut diamonds combine the appeal of a square cut diamond but with soft, rounded edges, lending this shape a romantic feel. This timeless shape is derived from the old mine cut, and has been refined over hundreds of years. Cushion cut diamonds are a beautiful choice for any setting style.</p>
                                </Col>

                                <Col lg={4} md={6} className='mb-5'>
                                    <img src={Emerald} className='mb-3' onMouseOver={(e) => e.currentTarget.src = RealEmerald} onMouseOut={(e) => e.currentTarget.src = Emerald} width={120} alt="" />
                                    <h2>Emerald Diamonds</h2>
                                    <p>Emerald cut diamonds are treasured for their elegant silhouette. The shallow pavilion and crown accentuate the clarity of the stone, while the reflective steps enhance the color and luster of the diamond</p>
                                </Col>

                                <Col lg={4} md={6} className='mb-5'>
                                    <img src={Pear} className='mb-3' onMouseOver={(e) => e.currentTarget.src = RealPear} onMouseOut={(e) => e.currentTarget.src = Pear} width={120} alt="" />
                                    <h2>Pear Diamonds</h2>
                                    <p>Pear shapes feature a rounded edge tapering to a point at the opposite end. This unique shape flatters fingers and offers a distinctive look. A fusion of the marquise shape and the most popular round brilliant cut, pear shaped diamonds are intended to showcase the sparkle of the diamond, making it important to find a stone with great symmetry.</p>
                                </Col>

                                <Col lg={4} md={6} className='mb-5'>
                                    <img src={Radiant} className='mb-3' onMouseOver={(e) => e.currentTarget.src = RealRadiant} onMouseOut={(e) => e.currentTarget.src = Radiant} width={120} alt="" />
                                    <h2>Radiant Diamonds</h2>
                                    <p>The radiant cut diamond combines the silhouette of an emerald cut diamond with the fire and sparkle of a round brilliant cut diamond. Due to its design, this shape requires more carat weight in the depth to maximize brilliance.</p>
                                </Col>

                                <Col lg={4} md={6} className='mb-5'>
                                    <img src={Oval} className='mb-3' onMouseOver={(e) => e.currentTarget.src = RealOval} onMouseOut={(e) => e.currentTarget.src = Oval} width={120} alt="" />
                                    <h2>Oval Diamonds</h2>
                                    <p>The ever-flattering oval shape is symmetrical and exhibits a similar fire and brilliance to round shaped diamonds. A scintillating twist on the classic round brilliant, the elongated shape can create the illusion of larger size. Oval diamonds are highly versatile, remarkably elegant, and distinctive.</p>
                                </Col>

                                <Col lg={4} md={6} className='mb-5'>
                                    <img src={Heart} className='mb-3' onMouseOver={(e) => e.currentTarget.src = RealHeart} onMouseOut={(e) => e.currentTarget.src = Heart} width={120} alt="" />
                                    <h2>Heart Diamonds</h2>
                                    <p>The heart shaped diamond is an evocative signifier of true love. They shimmer with two symmetrical halves, creating a bold and romantic look. Heart shaped diamonds are especially popular in Claddagh designs, and offer a distinctive look in any engagement ring setting.</p>
                                </Col>

                                <Col lg={4} md={6} className='mb-5'>
                                    <img src={Marquise} className='mb-3' onMouseOver={(e) => e.currentTarget.src = RealMarquise} onMouseOut={(e) => e.currentTarget.src = Marquise} width={120} alt="" />
                                    <h2>Marquise Diamonds</h2>
                                    <p>The marquise shaped diamond features pointed ends with a curved middle for an eye-catching look. With a larger surface area than any other diamond shape, the marquise shape maximizes perceived size and lends a unique look to any setting style.</p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div>

            <Container className='last-section'>
                <Row>
                    <Col xl={2}></Col>

                    <Col xl={10}>
                        <Row className='mt-40' id='section-7'>
                            <Col md={4}>
                                <img src={Anatomy} alt='' />
                            </Col>
                            <Col className='align-self-center'>
                                <h2 className='sub-heading'>The Diamond Anatomy</h2>
                                <p>A diamond is made up of two key sections, the Crown and the Pavilion. Their structure and relationship to each other in the form of table and depth percentages have the biggest impact on the diamond’s sparkle.</p>
                                <p>The round brilliant cut has been used as an example, because with most other diamond shapes (“fancy cut” diamonds) the cut grading is more complicated (hence why their cut grading does not appear on certificates such as GIA).</p>
                            </Col>
                        </Row>

                        <h2 className='mt-50 heading' id='section-8'>Diamond Care</h2>
                        <p>Depending on the setting you choose, you can soak your diamond engagement and/or wedding rings for up to 30 minutes in a solution of dish washing liquid and water. This is best suited to prong and cathedral settings. In pave and basket settings, however, soaking the rings can increase the likelihood of the gems coming loose. Be mindful of this when you decide to soak any jewelry piece use mild dish soap in warm water and soak your jewelry for a few minutes. Using a soft cloth or cotton swab, gently scrub the metal (gold, platinum, silver) and then rinse. Repeat the process if necessary, but always proceed with caution when it comes to soaking jewelry.</p>
                    </Col>
                </Row>        
            </Container>
            
                

            <Container>
                <Help />
            </Container>
        </div>
    </>
    
  )
}

export default LooseDiamondEducation;